import { PROFILE_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../modules/redux/utils/get-value'

function getLoggedPlansCountProfileUtil (profile) {
  return getValueReduxUtil(profile, PROFILE_KEY.LOGGED_PLANS_COUNT) || 0
}

export default getLoggedPlansCountProfileUtil
